<script setup lang="ts">
import { ref, Ref, watchEffect } from "vue";
import { useIntersectionObserver } from "@vueuse/core";
import { useI18n } from "vue-i18n";

const props = defineProps({ pageLoading: { type: Boolean, required: true } });
const emit = defineEmits(["nextPage"]);
const { t } = useI18n();
const loader: Ref<HTMLDivElement | null> = ref(null);
const loading = ref(false);

watchEffect(() => {
  loading.value = props.pageLoading;
});

useIntersectionObserver(loader, ([{ isIntersecting }]) => {
  if (isIntersecting && !loading.value) {
    emit("nextPage");
  }
});
</script>

<template>
  <div class="app-pagination">
    <span v-if="!loading" ref="loader" />
    <span class="icon main-loader" />
    <p>{{ t("system.loading") }}</p>
  </div>
</template>

<style scoped lang="scss">
.app-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  @include body-l();
  gap: $base-space;
  color: var(--color-semantic-content-normal-primary);

  > span {
    background-color: var(--color-semantic-content-normal-primary);
  }

  > p {
    position: relative;

    &::after {
      width: 100px;
      position: absolute;
      display: inline-block;
      animation: dots steps(1, end) 1s infinite;
      content: "";
      left: 100%;
    }
  }
}

@keyframes dots {
  0% {
    content: "";
  }
  25% {
    content: ".";
  }
  50% {
    content: "..";
  }
  75% {
    content: "...";
  }
  100% {
    content: "";
  }
}
</style>
